import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { Box } from '@chakra-ui/react';
import { ObjectImage, SingleObject } from '../../../types/ObjectTypes';
import { Link } from 'react-router-dom';
import { ObjectParams, ObjectsParams } from '../../../types/ParamsTypes';
import {
  getExtendedObjectRoute,
  getSimpleObjectRoute,
  isQualifiedToFetchWithExtendedParams,
} from '../../../services/Object/ObjectService';
import { CarouselContainer } from '../../../styles/CarouselStyled';

export interface ObjectListItemPreviewSliderProps {
  images: Array<ObjectImage>;
  object: SingleObject;
  objectsParams: ObjectsParams | ObjectParams;
}

export const PreviewSlider = (props: ObjectListItemPreviewSliderProps): JSX.Element => {
  const { images, object, objectsParams } = props;

  return (
    <Box w={{ base: '100%', xl: '50%' }} bg={'green.300'} borderRadius={4}>
      {!images.length && (
        <Box
          w={'100%'}
          h={300}
          backgroundSize={'cover'}
          backgroundImage={`url("https://via.placeholder.com/150")`}
          backgroundPosition={'center'}
        />
      )}
      <CarouselContainer>
        <Carousel showThumbs={false}>
          {images.map((image, idx) => {
            return (
              <Link
                key={idx}
                to={{
                  pathname: isQualifiedToFetchWithExtendedParams({
                    id: object.baseData.uniqueId,
                    fromDate: objectsParams.fromDate,
                    toDate: objectsParams.toDate,
                  })
                    ? getExtendedObjectRoute(object, objectsParams)
                    : getSimpleObjectRoute(object, objectsParams),
                }}
                target="_blank"
                style={{ width: '100%' }}>
                <Box
                  borderRadius={4}
                  w={'100%'}
                  h={300}
                  backgroundSize={'cover'}
                  backgroundImage={`url("${image.url}")`}
                  backgroundPosition={'center'}
                />
              </Link>
            );
          })}
        </Carousel>
      </CarouselContainer>
    </Box>
  );
};
